import React from "react";
import Add from "./Add";
import Edit from "./Edit";
import Overview from "./Overview";
export const Product = () => {
  return (
    <Overview />
  );
};

export const AddProduct = () => {
  return (
    <Add />
  );
};

export const EditProduct = () => {
  return (
    <Edit />
  );
};
